import { render, staticRenderFns } from "./NicheEdit.vue?vue&type=template&id=7e6026bb&"
import script from "./NicheEdit.vue?vue&type=script&lang=js&"
export * from "./NicheEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports